// extracted by mini-css-extract-plugin
export default {"wrapper":"verify-docs_wrapper__TIXyX"};